import * as styles from './styles.css';
import ReactMarkdown from 'react-markdown';

export interface ISectionItemProps {
  id: string;
  question: string;
  answer: string;
}

const SectionItem = ({ id, question, answer }: ISectionItemProps) => {
  return (
    <div id={id} className={styles.section.question}>
      <div className={styles.section.question_title}>{question}</div>
      {!Array.isArray(answer) && <div className={styles.section.question_answer}>{answer}</div>}
      {Array.isArray(answer) && (
        <div className={styles.section.multiple_answers}>
          {answer.map((line, index) => (
            <ReactMarkdown key={line + index} className={styles.section.question_answer}>
              {`${line}`}
            </ReactMarkdown>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionItem;
